// extracted by mini-css-extract-plugin
export default {"wrapper":"errorpage_wrapper__gDPmE","content":"errorpage_content__Ch4Sz"};